import { render, staticRenderFns } from "./FileDrop.vue?vue&type=template&id=9324989c&scoped=true&"
import script from "./FileDrop.vue?vue&type=script&lang=js&"
export * from "./FileDrop.vue?vue&type=script&lang=js&"
import style0 from "./FileDrop.vue?vue&type=style&index=0&id=9324989c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9324989c",
  null
  
)

/* custom blocks */
import block0 from "./FileDrop.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports